import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/sections/')({
  beforeLoad: () => {
    throw redirect({
      replace: true,
      to: '/sections/setup'
    })
  }
})
